import { render, staticRenderFns } from "./ModuleStudentsTermSlidebar.vue?vue&type=template&id=0abeb329"
import script from "./ModuleStudentsTermSlidebar.vue?vue&type=script&lang=js"
export * from "./ModuleStudentsTermSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports